export const create = {
  createSuccessfully: '新しい顧客を正常に作成しました！',
}
